import styled from '@emotion/styled';
import { Button, Stack } from '@mui/material';
import { InputField } from 'components';
import InlineError from 'components/common/ErrorInline';
import { SYS_MESS } from 'constants/systemMessage';
import { useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { updateOverallDataSubmit } from 'store/reducers/trial-request';

const ParentSignatureWrapper = styled(Stack)({
  flexDirection: 'column',
  gap: 5,
  '& .inputSign': {
    height: 80,
  },
  '& .placeholder': {
    position: 'absolute',
    top: '50%',
    left: 20,
    transform: 'translateY(-50%)',
  },
  '& .MuiTypography-root': {
    paddingBottom: 5,
  },
});

interface YourSignatureProps {
  isScrollBottom?: boolean;
  isTickAll?: boolean;
  onSubmitCallback: () => void;
}

const ParentSignature = ({
  isTickAll,
  onSubmitCallback,
}: YourSignatureProps) => {
  const dispatch = useAppDispatch();
  const { overallDataSubmit } = useAppSelector((state) => state.baseRequest);

  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const [valueSignature, setValueSignature] = useState<string | null>(null);

  // const sigRef = useRef<SignatureCanvas>();

  // const handleEndSignature = (): void => {
  //   if (!sigRef.current) return;
  //   setValueSignature(sigRef.current.toDataURL());
  // };

  // const _clearSignature = (): void => {
  //   if (!sigRef.current) return;
  //   sigRef.current.clear();
  //   setValueSignature(null);
  // };

  const onSubmit = () => {
    setIsInitialLoad(false);
    if (!valueSignature) {
      setValueSignature('');
    } else {
      dispatch(
        updateOverallDataSubmit({
          ...overallDataSubmit,
          parentSignature: valueSignature,
        }),
      );
      onSubmitCallback();
    }
  };

  const isError = useMemo(() => {
    return valueSignature === '' || valueSignature === null;
  }, [valueSignature]);

  return (
    <ParentSignatureWrapper>
      <InputField
        placeholder="Type your signature"
        value={valueSignature}
        onChange={(e) => setValueSignature(e.target.value)}
        className="inputSign"
      />
      <InlineError
        open={!isInitialLoad && isError}
        error={SYS_MESS.ERROR.COMMON.FILL_DATA}
      />
      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={!isTickAll || isError}
        sx={{ width: '200px', ml: 'auto' }}
      >
        Submit
      </Button>
    </ParentSignatureWrapper>
  );
};

export default ParentSignature;
